(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-visual-header"]) return;
  try {
    
  function preserveCollectionView() {
    const header = document.querySelector('[data-cg-collection-view]');
    if (!header) return;
    const view = header.dataset.cgCollectionView;
    const collectionPath = header.dataset.collectionPath;
    document.querySelectorAll('.collection-products .facets-form').forEach(form => {
      form.querySelectorAll('.facets__price input[type="number"]').forEach(input => { input.step = '0.01'; });
      if (!view) return;
      if (form.querySelector('input[name="view"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'view';
      input.value = view;
      form.append(input);
    });
    if (!view) return;
    document.querySelectorAll('.collection-products a[href]').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin || url.pathname.includes('/products/')) return;
      if (url.pathname !== collectionPath && !url.pathname.startsWith(collectionPath + '/')) return;
      url.searchParams.set('view', view);
      link.href = url.pathname + url.search + url.hash;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preserveCollectionView, { once: true });
  } else {
    preserveCollectionView();
  }
  document.addEventListener('shopify:section:load', preserveCollectionView);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  function initializeCollectionSort() {
    document.querySelectorAll('.collection-products .facets-form--sort-only').forEach(form => form.classList.add('facets-form--auto-sort'));
  }
  initializeCollectionSort();
  document.addEventListener('shopify:section:load', initializeCollectionSort);
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (select instanceof HTMLSelectElement && select.matches('.collection-products .facets-form__sort select')) {
      select.form?.requestSubmit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cg-newsletter')) {
    customElements.define('cg-newsletter', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        if (!this.form || !window.fetch) return;
        if (this.form.hasAttribute('data-hcaptcha-bound')) return;
        this.message = this.querySelector('[data-newsletter-result]');
        this.button = this.form.querySelector('button[type="submit"]');
        this.email = this.form.querySelector('input[type="email"]');
        this.label = this.button.textContent;
        const nativeSubmit = HTMLFormElement.prototype.submit.bind(this.form);
        this.form.submit = () => {
          if (this.nativeNext) { nativeSubmit(); return; }
          if (!this.pending) this.send();
        };
        this.form.addEventListener('submit', (event) => {
          if (this.pending || this.protecting) { event.preventDefault(); event.stopImmediatePropagation(); return; }
          if (event.defaultPrevented || this.nativeNext) return;
          if (this.form.hasAttribute('data-hcaptcha-bound')) return;
          event.preventDefault();
          if (!this.form.reportValidity()) return;
          if (window.Shopify?.captcha?.protect) {
            this.protecting = true;
            const release = setTimeout(() => { this.protecting = false; }, 20000);
            window.Shopify.captcha.protect(this.form, () => {
              clearTimeout(release);
              this.protecting = false;
              this.form.submit();
            });
          } else {
            this.form.submit();
          }
        });
      }

      async send() {
        this.pending = true;
        this.form.setAttribute('aria-busy', 'true');
        this.message.hidden = true;
        this.email.removeAttribute('aria-invalid');
        const data = new URLSearchParams(new FormData(this.form));
        this.button.disabled = true;
        this.button.textContent = this.dataset.loading;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch(this.form.action, {
            method: 'POST', body: data, credentials: 'same-origin',
            headers: { Accept: 'text/html' }, signal: controller.signal
          });
          const destination = new URL(response.url);
          if (destination.origin !== location.origin) throw new Error('Unexpected response origin');
          if (destination.pathname.replace(/\/$/, '') === '/challenge') {
            location.assign(destination.href);
            return;
          }
          if (!response.ok) throw new Error('Signup could not be confirmed');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = page.getElementById(this.form.id)?.querySelector('[data-newsletter-result]');
          if (result?.dataset.newsletterResult === 'success') {
            this.message.replaceChildren(...Array.from(result.childNodes, (node) => document.importNode(node, true)));
            this.message.dataset.newsletterResult = 'success';
            this.message.className = 'form-message form-message--success';
            this.message.hidden = false;
            this.form.querySelector('.newsletter-form__field').hidden = true;
            this.message.focus({ preventScroll: true });
          } else if (result?.dataset.newsletterResult === 'error') {
            this.showError(result.textContent.trim());
            this.email.setAttribute('aria-invalid', 'true');
          } else {
            this.nativeNext = true;
            throw new Error('Native verification required');
          }
        } catch {
          this.showError(this.dataset.error);
        } finally {
          clearTimeout(timeout);
          this.pending = false;
          this.form.removeAttribute('aria-busy');
          this.button.disabled = false;
          this.button.textContent = this.label;
        }
      }

      showError(text) {
        this.message.textContent = text;
        this.message.dataset.newsletterResult = 'error';
        this.message.className = 'form-message form-message--error';
        this.message.hidden = false;
        this.message.focus({ preventScroll: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
